import { Inject, Injectable, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EqValidator } from '../interfaces/eq-validators.interface';
import { Default } from '../interfaces';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EqFormService {
  // demo search data api
  // apiUrl: string = 'https://jsonplaceholder.typicode.com/users';

  constructor(
    private http: HttpClient,
    @Inject('environment') private envrionment: any,

  ) {}

  public addFormControl(
    form: any,
    controlName: string,
    validators: EqValidator[]
  ) {
    if (!form || !controlName) return null;
    form?.addControl(
      controlName,
      new FormControl(
        '',
        validators.map((elm: EqValidator) => elm.validators)
      )
    );
    return form;
  }

  public getErrorMessage(
    form: any,
    controlName: string,
    validators: EqValidator[]
  ): string {
    if (!form || !controlName) return '';
    for (const elm of validators) {
      if (form.get(controlName).hasError(elm.error)) {
        return elm.message ? elm.message : this.getDefaultErrMsg(elm.error);
      }
    }
    return '';
  }

  search(query: any, apiUrl?: string, extraQuery: Array<{name: string, value: any}> = []): Observable<any> {
    let url;
    if(apiUrl) {
      url = `${this.envrionment.apiUrl}/${apiUrl}`;
    } else {
      url = `${this.envrionment.apiUrl}`;
    }
    let headers = new HttpHeaders({
      'is-cached': 'false',
    });
    let params = new HttpParams();
    if (query.name) {
      params = params.append('name', query.name);
    }
    extraQuery.forEach((elm)=>{
      params = params.append(elm.name, elm.value)
    })
    return this.http.get(url, { headers, params });
  }

  public hasError(form: any, controlName: string): boolean {
    if (!form || !controlName) return false;
    return (
      form.get(controlName)?.invalid &&
      form.get(controlName)?.errors &&
      (form.get(controlName)?.dirty || form.get(controlName)?.touched)
    );
  }
  public isValid(form: any, controlName: string){
    if (!form || !controlName) return false;
    return (
      form.get(controlName)?.valid
    );
  }

  public isTouched(form: any, controlName: string){
    if (!form || !controlName) return false;
    return (
      form.get(controlName).touched
    );
  }

  private getDefaultErrMsg(errName: string): string {
    const DEFAULT_ERR_MSG: Default = {
      required: 'This Field is required.',
      email: 'Please enter a valid email',
      pattern: 'It should match the rquired pattern',
      maxlength: 'Max length should be',
      minlenght: 'Min length should be',
    };
    return DEFAULT_ERR_MSG[errName];
  }
}
